import { render, staticRenderFns } from "./SurveyUpload.vue?vue&type=template&id=957bf04c&scoped=true"
import script from "./SurveyUpload.vue?vue&type=script&lang=js"
export * from "./SurveyUpload.vue?vue&type=script&lang=js"
import style0 from "./SurveyUpload.vue?vue&type=style&index=0&id=957bf04c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957bf04c",
  null
  
)

export default component.exports